export const applicationStatusApis = {
    
    getPrimaryStatusesList: "v1/api/applicationStatus/primaryStatus",
    getPrimaryStatusesListUpdate: "v1/api/applicationStatus/primaryStatus/update",
    createPrimaryStatuses: "v1/api/applicationStatus/primaryStatus",
    getPrimaryStatusesbyId: "v1/api/applicationStatus/primaryStatus/:primaryStatusId",
    updatePrimaryStatusesById: "v1/api/applicationStatus/primaryStatus?primaryStatusId=:primaryStatusId",
    deletePrimaryStatusesId: "v1/api/applicationStatus/primaryStatus?primaryStatusId=:primaryStatusId",

    getSecondaryStatusesList: "v1/api/applicationStatus/secondaryStatus",
    getSecondaryStatusesListupdate: "v1/api/applicationStatus/secondaryStatus/update",
    createSecondaryStatuses: "v1/api/applicationStatus/secondaryStatus",
    getSecondaryStatusesbyId: "v1/api/applicationStatus/secondaryStatus?primaryStatusId=",
    updateSecondaryStatusesById: "v1/api/applicationStatus/secondaryStatus?secondaryStatusId=:secondaryStatusId",
    deleteSecondaryStatusesId: "v1/api/applicationStatus/secondaryStatus?secondaryStatusId=:secondaryStatusId",

    getAutoUpdateStatusList: "v1/api/applicationStatus/autoUpdateStatus",
    createAutoUpdateStatuses: "v1/api/applicationStatus/autoUpdateStatus",
    getAutoUpdateStatusesbyId: "v1/api/applicationStatus/autoUpdateStatus/:autoUpdateStatusId",
    updateAutoUpdateStatusesById: "v1/api/applicationStatus/autoUpdateStatus?autoUpdateStatusId=:autoUpdateStatusId",
    deleteAutoUpdateStatusesId: "v1/api/applicationStatus/autoUpdateStatus?autoUpdateStatusId=:autoUpdateStatusId",
    autoChangesUpload: 'v1/api/adminDocumentUpload',
    getAutoUpdateStatusesUploadDoc: 'v1/api/adminDocumentUpload?referanceId=',

    getAgentCommunicationStatusStatusList: "v1/api/applicationStatus/agentCommunicationStatus",
    createAgentCommunicationStatusStatuses: "v1/api/applicationStatus/agentCommunicationStatus",
    getAgentCommunicationStatusStatusesbyId: "v1/api/applicationStatus/agentCommunicationStatus/:agentCommunicationStatusId",
    updateAgentCommunicationStatusStatusesById: "v1/api/applicationStatus/agentCommunicationStatus?agentCommunicationStatusId=:agentCommunicationStatusId",
    deleteAgentCommunicationStatusStatusesId: "v1/api/applicationStatus/agentCommunicationStatus?agentCommunicationStatusId=:agentCommunicationStatusId",

    getInternalStatusStatusList: "v1/api/applicationStatus/internalStatus",
    createInternalStatusStatuses: "v1/api/applicationStatus/internalStatus",
    getInternalStatusStatusesbyId: "v1/api/applicationStatus/internalStatus/:internalStatusId",
    updateInternalStatusStatusesById: "v1/api/applicationStatus/internalStatus?internalStatusId=:internalStatusId",
    deleteInternalStatusStatusesId: "v1/api/applicationStatus/internalStatus?internalStatusId=:internalStatusId",
}
